export default __webpack_public_path__ + "static/media/IconEdit.9eacf7a3.svg";